// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ScissorsOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"aria-labelby":"title","fill":"currentColor","viewBox":"0 0 448 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M278.06 256L444.48 89.57a12 12 0 000-16.97 84 84 0 00-118.79 0L210.18 188.12l-24.86-24.86A95.82 95.82 0 00192 128c0-53.02-42.98-96-96-96S0 74.98 0 128a96 96 0 00109.36 95.07L142.29 256l-32.93 32.93A96 96 0 000 384c0 53.02 42.98 96 96 96s96-42.98 96-96a95.82 95.82 0 00-6.68-35.26l24.86-24.86L325.69 439.4a84 84 0 00118.79 0 12 12 0 000-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"}}]},"name":"scissors","theme":"outlined"};

const ScissorsOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ScissorsOutlinedSvg} />;
  ScissorsOutlined.displayName = 'ScissorsOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ScissorsOutlined);
